import React, { ChangeEvent, useState } from 'react'
import { Button } from '@/components/ui/button'
import { Body2, Heading3 } from '@/components/ui/typography'
import { NameDto } from 'api/Common/Types'
import { Modal } from 'components/CustomModal'
import { Select } from 'components/Select'
import { Field } from 'formik'
import { FormFieldContainer } from 'routes/Records/Clients/Details/Client.styles'
import styled from 'styled-components'

import { SelectVersion } from '../../SelectVersion'
import { FeatureFlagVersion } from '../FeatureFlags'

interface OuterProps {
  data: FeatureFlagVersion | null
  handleAdd(values: FeatureFlagVersion): void
  handleEdit(values: FeatureFlagVersion): void
}

const defaultFlag = { isEnabled: false }

export const FeatureFlagModal: React.FC<OuterProps> = ({ handleEdit, handleAdd, data }) => {
  const [featureFlag, setFeatureFlag] = useState<FeatureFlagVersion>(data ?? defaultFlag)
  const [versionModal, setVersionModal] = useState(false)

  const changeVersion = (newVersion: NameDto<string>) => {
    setFeatureFlag((prev) => ({ ...prev, version: newVersion }))
    setVersionModal(false)
  }

  const submit = () => {
    if (data && featureFlag) handleEdit(featureFlag)
    else handleAdd(featureFlag)
  }

  return (
    <Container>
      {versionModal && (
        <Modal width={1300} visible={versionModal} onClose={() => setVersionModal(false)}>
          <SelectVersion initialValue={data?.version?.id} onChange={changeVersion} />
        </Modal>
      )}

      <Heading3 className='flex flex-row justify-center items-center'>
        {data ? 'Edit' : 'Add New'} <Body2 className='text-[#0e76eb] pl-1'>Version</Body2>
      </Heading3>

      <FormFieldContainer>
        <Body2 as='label' bold>
          Version *
        </Body2>{' '}
        <Select
          labelInValue={true}
          placeholder='Choose Version'
          fullWidth
          open={false}
          value={featureFlag?.version?.name}
          onFocus={() => setVersionModal(true)}
        />
      </FormFieldContainer>
      <FormFieldContainer>
        <Body2 as='label' bold>
          Enabled
        </Body2>
        <Field
          type='checkbox'
          checked={featureFlag.isEnabled}
          onChange={(v: ChangeEvent<HTMLInputElement>) =>
            setFeatureFlag((prev) => ({ ...prev, isEnabled: v.target.checked }))
          }
        />
      </FormFieldContainer>

      <FormFieldContainer>
        <Button type='button' disabled={!featureFlag.version?.id} onClick={submit}>
          {data ? 'Edit' : 'Add'}
        </Button>
      </FormFieldContainer>
    </Container>
  )
}

const Container = styled.div`
  margin: 2.5rem;
`
